import React from 'react'

import type { WCDRouteProps } from '.'
import { Page } from './components/Page'

const articleSlug = ':articleSlug(.*-[a-zA-Z0-9]{12})'
const nonCommercialSlug = ':articleSlug(which-launches-insurance-super-complaint-[a-zA-Z0-9]{12})'

export const articlePageRoutes: WCDRouteProps = [
  {
    live: true,
    exact: true,
    path: `/:verticalSlug(about-which|help)/${articleSlug}`,
    component: () => <Page pagePath="article/AboutWhichArticlePage" />,
  },
  {
    live: true,
    exact: true,
    path: `/:verticalSlug(consumer-rights)/:articleType(advice)/:articleSlug(the-car-i-bought-has-a-problem-what-are-my-rights-[a-zA-Z0-9]{12})`,
    component: () => (
      <Page pagePath="article/ConsumerRightsCarAdviceToolPage" context="consumer-rights" />
    ),
  },
  {
    live: true,
    exact: true,
    path: [
      `/:verticalSlug(consumer-rights)/:articleType(advice)/:articleSlug(how-to-get-your-money-back-after-a-scam-[a-zA-Z0-9]{12})`,
      `/:verticalSlug(consumer-rights)/:articleType(advice)/:articleSlug(how-to-spot-a-scam-[a-zA-Z0-9]{12})`,
      `/:verticalSlug(consumer-rights)/:articleType(advice)/:articleSlug(how-to-report-a-scam-[a-zA-Z0-9]{12})`,
    ],
    component: () => <Page pagePath="article/ConsumerRightsScamsPage" context="consumer-rights" />,
  },
  {
    live: true,
    exact: true,
    path: `/:verticalSlug(consumer-rights)/:articleType(advice|letter|regulation)/${articleSlug}`,
    component: () => <Page pagePath="article/ConsumerRightsPage" context="consumer-rights" />,
  },
  {
    live: true,
    exact: true,
    path: `/:verticalSlug(money)/:subVerticalSlug/:categorySlug/:collectionSlug/${articleSlug}`,
    component: () => <Page pagePath="article/ReviewsAdviceMultiPage" context="money" />,
  },
  {
    live: true,
    exact: true,
    path: `/:verticalSlug(money)/:subVerticalSlug/:categorySlug/${articleSlug}`,
    component: () => <Page pagePath="article/ReviewsAdviceSinglePage" context="money" />,
  },
  {
    live: true,
    exact: true,
    path: [
      `/news/:year([0-9]{4})/:month([0-9]{2})/${nonCommercialSlug}`,
      `/news/article/${nonCommercialSlug}`,
    ],
    component: () => <Page pagePath="article/NonCommercialArticlePage" context="news" />,
  },
  {
    live: true,
    exact: true,
    path: [`/news/:year([0-9]{4})/:month([0-9]{2})/${articleSlug}`, `/news/article/${articleSlug}`],
    component: () => <Page pagePath="article/NewsArticlePage" context="news" />,
  },
  {
    live: true,
    exact: true,
    path: `/:verticalSlug(pension-scheme)/${articleSlug}`,
    component: () => <Page pagePath="article/PensionArticlePage" />,
  },
  {
    live: true,
    exact: true,
    path: `/policy-and-insight/article/${articleSlug}`,
    component: () => <Page pagePath="article/PIArticlePage" context="policy-and-insight" />,
  },
  {
    live: true,
    exact: true,
    path: `/reviews/:superCategorySlug/article/:collectionSlug/${articleSlug}`,
    component: () => <Page pagePath="article/ReviewsAdviceMultiPage" context="reviews" />,
  },
  {
    live: true,
    exact: true,
    path: `/reviews/:superCategorySlug/article/${articleSlug}`,
    component: () => <Page pagePath="article/ReviewsAdviceSinglePage" context="reviews" />,
  },
  {
    live: true,
    exact: true,
    path: '/free-account-exclusive',
    component: () => (
      <Page pagePath="article/FreeAccountArticlePage" context="free-account-exclusive" />
    ),
  },
]
